module.exports = __webpack_public_path__ + "static/media/ic_删除3.7404c847.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic_删除3.svg
// module id = 78
// module chunks = 0